<template>
    <div class="order-center">
        <el-table :data="orderList" border>
            <el-table-column prop="title" label="产品"></el-table-column>
            <el-table-column prop="order_no" label="订单号"></el-table-column>
            <el-table-column prop="create_time" label="创建时间">
                <template slot-scope="scope">{{ scope.row.create_time }}</template>
            </el-table-column>
            <el-table-column prop="real_price" label="金额" width="90">
                <template slot-scope="scope">￥{{ formatPrice(scope.row.real_price) }}</template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="90">
                <template slot-scope="scope">{{ getStatusText(scope.row.status) }}</template>
            </el-table-column>
            <el-table-column label="操作" width="240" >
                <template slot-scope="scope" >
                    <el-button v-if="scope.row.status === 0" type="danger" size="mini"
                        @click="cancelOrder(scope.row)">取消订单</el-button>
                    <el-button v-if="scope.row.status === 0" type="primary" size="mini"
                        @click="payWithAlipay(scope.row)">支付宝付款</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
  
<script>
import { OrderAPI } from "../api/order";

export default {
    data() {
        return {
            orderList: []
        };
    },
    created() {
        if (!this.isLogin) {
            this.$message.warning("请先登录！")
            this.$router.replace("/")
            return
        }
    },
    mounted() {
        // 在实际应用中，从接口获取订单列表数据
        this.fetchOrderList();
    },
    methods: {
        fetchOrderList() {
            OrderAPI.queryOrderList().then(res => {
                this.orderList = res;
            })

            // 模拟从接口获取订单列表数据的过程
            // const response = [
            //     {
            //         order_no: "dev-2023050800120001",
            //         title: "gpt3-月套餐-100w字-新购-1个月",
            //         origin_price: 1,
            //         real_price: 1,
            //         status: 4,
            //         pay_expire: "2023-05-08 00:27:31",
            //         pay_time: "2023-05-08 00:14:58",
            //         create_time: "2023-05-08 00:12:31"
            //     }
            // ];
            // this.orderList = response;
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString();
        },
        formatPrice(price) {
            return (price / 100).toFixed(2);
        },
        getStatusText(status) {
            const statusMap = {
                0: "待支付",
                1: "已支付",
                2: "已取消",
                3: "已超时",
                4: "已完成"
            };
            return statusMap[status] || "";
        },
        cancelOrder(order) {
            // 取消订单逻辑
            OrderAPI.cancelOrder(order.order_no).then(res => {
                this.$message.success("订单已取消！")
                this.fetchOrderList()
            })
        },
        payWithAlipay(order) {
            // 使用支付宝付款逻辑
            OrderAPI.prepayOrder(order.order_no).then(res => {
                this.openNewTab(res.pay_html)
            })
        },
        redirectPayHtml(payHtml) {
            // 跳转到支付页面

        },
        openNewTab(htmlText) {
            // 创建一个新的窗口
            const newWindow = window.open();

            // 给新窗口设置HTML内容
            newWindow.document.write(`
                <html>
                <body>
                    ${htmlText}
                </body>
                </html>
            `);
        }
    },
    computed: {
        isLogin() {
            return this.$store.state.isLogin
        },
    }
};
</script>
  
<style scoped>
.order-center {
    background-color: #ffffff;
    padding: 16px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/OrderCenter.vue